import moment from 'moment'
import { mergeDeepRight, includes, isNil } from '@neo/ramda-extra'

export const belongTo = (applicantId) => ({ applicants }) =>
  includes(applicantId)(applicants)
export const addMissingFields = mergeDeepRight

export const convertISODate = (date) =>
  isNil(date) ? undefined : moment(date).format('DD/MM/YYYY')
